import { ThemeUICSSObject } from '@apia/theme';
import primary from './primary';
import tab from './tab';
import tabPrimary from './tabPrimary';
import defaultAccordion from './default';
/* IMPORT HERE */

const accordionElement: ThemeUICSSObject = {
  primary,
  tab,
  tabPrimary,
  default: defaultAccordion,
  /* PREPEND HERE */
};

export default accordionElement;
